import { render } from "./CreateOrderPolicy.vue?vue&type=template&id=67b64f94"
import script from "./CreateOrderPolicy.vue?vue&type=script&lang=js"
export * from "./CreateOrderPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__